import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Award, Building2, ShieldCheck, Users } from "lucide-react";

export default function Hakkimizda() {
  return (
    <>
      <PageHeader
        eyebrow="Kurumsal"
        title="Hakkımızda"
        description="Yalova'da 20 yılı aşkın süredir hizmet veren güvenilir döviz büromuz."
        image="https://images.unsplash.com/photo-1632507127789-eb70cc8757af"
      />
      <section className="py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {[
              { icon: <Award className="w-6 h-6" />, n: "20+", l: "Yıllık Tecrübe" },
              { icon: <Users className="w-6 h-6" />, n: "10K+", l: "Memnun Müşteri" },
              { icon: <ShieldCheck className="w-6 h-6" />, n: "100%", l: "Güvenli İşlem" },
            ].map((s, i) => (
              <div key={i} className="p-7 rounded-2xl bg-slate-50 border border-slate-200">
                <div className="text-brand-gold mb-3">{s.icon}</div>
                <div className="font-display text-4xl font-bold text-slate-950 mb-1">{s.n}</div>
                <div className="text-sm text-slate-600 uppercase tracking-wider">{s.l}</div>
              </div>
            ))}
          </div>

          <div className="prose prose-slate max-w-none">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-950 tracking-tight mb-6">
              Yalova'nın Köklü Döviz Markası
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed mb-6">
              Akaydın Döviz, Yalova'nın merkezinde, Fevzi Çakmak Mahallesi İstanbul Caddesi üzerinde
              hizmet veren, yıllarını döviz ve kıymetli maden alım-satımına adamış bir kurumdur.
              İlk günden bu yana, müşterilerimize en güncel piyasa kurları üzerinden, şeffaf,
              güvenilir ve hızlı bir hizmet sunmayı ilke edindik.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Bireysel müşterilerimizin yanı sıra kurumsal müşterilere de özel çözümler üretiyoruz.
              Tüm işlemlerimiz yetkilendirilmiş ve denetlenen finansal süreçlere uygun olarak
              gerçekleştirilir. Müşteri memnuniyeti, etik değerler ve güven; iş yapış biçimimizin
              temelini oluşturur.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Modern altyapımız sayesinde web sitemiz üzerinden anlık döviz ve altın
              bilgilerine kolayca ulaşabilir, döviz çeviricimizi kullanarak işlemlerinizi
              planlayabilirsiniz.
            </p>
          </div>

          <div className="mt-16 p-8 md:p-10 rounded-2xl bg-slate-950 text-white">
            <div className="flex items-center gap-3 text-brand-gold mb-3">
              <Building2 className="w-5 h-5" />
              <span className="text-[11px] uppercase tracking-[0.25em] font-bold">Merkez</span>
            </div>
            <h3 className="font-display text-2xl md:text-3xl font-bold mb-3">
              Akaydın Döviz Ve Altın Ticareti Sınırlı Yetkili Müessese A.Ş.
            </h3>
            <p className="text-brand-gold text-xs font-bold uppercase tracking-[0.25em] mb-3">
              B Grubu Yetkili Müessese · Yalova Şubesi
            </p>
            <p className="text-slate-300 leading-relaxed">
              Fevzi Çakmak Mahallesi, İstanbul Caddesi No:4, 77100 Merkez/Yalova
              <br />
              Telefon: +90 226 811 29 50 · GSM: 0540 080 49 77
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
